"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    dewDifferential_ABOVE: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    dewDifferential_BELOW: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    dewDifferential_IN: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    dewPoint_ABOVE: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    dewPoint_BELOW: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    dewPoint_IN: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    humidity_ABOVE: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    humidity_BELOW: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    humidity_IN: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    precipitation: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    sunrise: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    sunset: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    temperature_ABOVE: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    temperature_BELOW: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    temperature_IN: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    temperatureInversion_ABOVEvsBELOW: _aggregation_helpers_1.hourlyOrUnaggregatedOnlyAggregationIntervalHelper,
    temperatureInversion_ABOVEvsIN: _aggregation_helpers_1.hourlyOrUnaggregatedOnlyAggregationIntervalHelper,
    weatherIcon: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    wetBulb_ABOVE: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    wetBulb_BELOW: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    wetBulb_IN: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    windDirection: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    windSpeed: _aggregation_helpers_1.defaultAggregationIntervalHelper,
};
//# sourceMappingURL=weather.js.map